// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Different from ebi-global.css tag to wrap long lines */\n.gxaTag {\n  margin: 0 0.2rem 0.5rem 0;\n  padding: 0.5rem 0.5rem;\n  font-size: 0.8rem;\n  line-height: 2.5;\n  color: white;\n  background-color: #3497c5;\n  border-bottom: none;\n}\n", ""]);
// Exports
module.exports = exports;
